export default "__VITE_ASSET__c636b1e6__"